import {getCompanySubdomain} from "../../../shared/ApiService";

const storeUrlMode = process.env.REACT_APP_STORE_URL_MODE; // single or subdomain
const storeUrlProtocol = process.env.REACT_APP_STORE_URL_PROTOCOL;
const storeUrlDomain = process.env.REACT_APP_STORE_URL_DOMAIN;
const storeUrlDevPath = 'store';

export function getStoreExternalUrl(url, providedSubdomain = '', copyMode = false) {
    const subdomain = providedSubdomain || getCompanySubdomain();
    const {host} = window.location;

    const rootPath = storeUrlMode === 'subdomain' ?
        `${storeUrlProtocol}://${subdomain}.${storeUrlDomain}` :
        `${copyMode ? host : ''}/${storeUrlDevPath}/${subdomain}`;

    if (url === '/')
        return rootPath;

    if (url[0] === '/')
        return rootPath + url;

    return `${rootPath}/${url}`;
}
